import React from 'react';

export const TableMobile = ({ className, children }) => {
  return (
    <div className="d-block d-md-none">
      <div className={`d-flex flex-wrap ${className}`}>{children}</div>
    </div>
  );
};

export const TableMobileIterative = ({ line, columns, className }) => {
  return (
    <div className="d-block d-md-none">
      <div className={`d-flex flex-wrap ${className}`}>
        {line.map((item, index) => {
          return (
            <div className="col-6" key={item}>
              <div className="thead">{columns[index]}</div>
              <div className="td">{item}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
